/**
 * V1 graceful exit scenarios — educational copy, not credit denials.
 */

export const V1_EXIT_IDS = {
  SELF_EMPLOYED: 'self-employed',
  CREDIT_BELOW_580: 'credit-below-580',
  INVESTMENT_SECOND_HOME: 'investment-second-home',
  ZERO_DOWN: 'zero-down',
  FHA_CASH_OUT: 'fha-cash-out',
  OTHER_LOAN_TYPE: 'other-loan-type',
  NON_CITIZEN: 'non-citizen',
  PROPERTY_TYPE: 'property-type',
  VA_PURCHASE: 'va-purchase',
  INSUFFICIENT_DOWN: 'insufficient-down',
  NON_W2_REFI: 'non-w2-refi',
  FHA_BANKRUPTCY: 'fha-bankruptcy',
};

export const V1_EXITS = {
  [V1_EXIT_IDS.SELF_EMPLOYED]: {
    id: V1_EXIT_IDS.SELF_EMPLOYED,
    severity: 'hard',
    title: 'W-2 income only in this version',
    body: 'LoanKnow V1 helps borrowers with W-2 employment. We are adding self-employed support soon.',
    allowEmailCapture: true,
    allowContinueGeneric: false,
  },
  [V1_EXIT_IDS.CREDIT_BELOW_580]: {
    id: V1_EXIT_IDS.CREDIT_BELOW_580,
    severity: 'educational',
    title: 'Credit band below typical program floors',
    body: 'Many government and conventional programs look for a 580+ credit score. You can leave your email for follow-up resources.',
    allowEmailCapture: true,
    allowContinueGeneric: false,
  },
  [V1_EXIT_IDS.INVESTMENT_SECOND_HOME]: {
    id: V1_EXIT_IDS.INVESTMENT_SECOND_HOME,
    severity: 'hard',
    title: 'Primary residence only',
    body: 'LoanKnow V1 focuses on loans for a home you will live in as your primary residence.',
    allowEmailCapture: true,
    allowContinueGeneric: false,
  },
  [V1_EXIT_IDS.ZERO_DOWN]: {
    id: V1_EXIT_IDS.ZERO_DOWN,
    severity: 'educational',
    title: 'Down payment needed for this path',
    body: 'For purchases in V1, you will need at least 3% down for conventional or 3.5% for FHA at most credit bands.',
    allowEmailCapture: true,
    allowContinueGeneric: false,
  },
  [V1_EXIT_IDS.INSUFFICIENT_DOWN]: {
    id: V1_EXIT_IDS.INSUFFICIENT_DOWN,
    severity: 'educational',
    title: 'Down payment may be too low',
    body: 'Based on what you entered, your down payment may be below common minimums. You can adjust your numbers or leave your email for updates.',
    allowEmailCapture: true,
    allowContinueGeneric: true,
  },
  [V1_EXIT_IDS.FHA_CASH_OUT]: {
    id: V1_EXIT_IDS.FHA_CASH_OUT,
    severity: 'educational',
    title: 'FHA cash-out not in V1',
    body: 'FHA cash-out refinance is not part of LoanKnow V1. If you have a conventional loan, you may explore conventional cash-out instead.',
    allowEmailCapture: true,
    allowContinueGeneric: false,
  },
  [V1_EXIT_IDS.OTHER_LOAN_TYPE]: {
    id: V1_EXIT_IDS.OTHER_LOAN_TYPE,
    severity: 'hard',
    title: 'Loan type not supported yet',
    body: 'LoanKnow V1 supports FHA, VA (IRRRL only), and conventional paths listed in our product set.',
    allowEmailCapture: true,
    allowContinueGeneric: false,
  },
  [V1_EXIT_IDS.NON_CITIZEN]: {
    id: V1_EXIT_IDS.NON_CITIZEN,
    severity: 'hard',
    title: 'Citizenship scope',
    body: 'V1 supports U.S. citizens and permanent residents preparing files for lenders.',
    allowEmailCapture: true,
    allowContinueGeneric: false,
  },
  [V1_EXIT_IDS.PROPERTY_TYPE]: {
    id: V1_EXIT_IDS.PROPERTY_TYPE,
    severity: 'hard',
    title: 'Single-family homes only',
    body: 'LoanKnow V1 supports detached single-family primary residences. Condo and multi-unit support is coming later.',
    allowEmailCapture: true,
    allowContinueGeneric: false,
  },
  [V1_EXIT_IDS.VA_PURCHASE]: {
    id: V1_EXIT_IDS.VA_PURCHASE,
    severity: 'hard',
    title: 'VA purchase not in V1',
    body: 'LoanKnow V1 includes VA IRRRL refinances only, not VA purchase loans yet.',
    allowEmailCapture: true,
    allowContinueGeneric: false,
  },
  [V1_EXIT_IDS.NON_W2_REFI]: {
    id: V1_EXIT_IDS.NON_W2_REFI,
    severity: 'hard',
    title: 'W-2 income only in this version',
    body: 'LoanKnow V1 refinance preparation is built for W-2 borrowers.',
    allowEmailCapture: true,
    allowContinueGeneric: false,
  },
  [V1_EXIT_IDS.FHA_BANKRUPTCY]: {
    id: V1_EXIT_IDS.FHA_BANKRUPTCY,
    severity: 'educational',
    title: 'Bankruptcy seasoning',
    body: 'FHA often requires two years from Chapter 7 discharge (lender verifies). You can still leave your email for educational follow-up.',
    allowEmailCapture: true,
    allowContinueGeneric: true,
  },
};

export const getV1Exit = (id) => V1_EXITS[id] || null;
